export const agent = {
  yqmh: "Boîte mystère d'invitation",
  yqzmh: "Gagner des boîtes mystère par invitation",
  bfbkj: "100% de chance de gain",
  yqpy: "Inviter des amis",
  pywczcrw: "L'ami s'inscrit et accomplit les tâches",
  hdcmhcs: "Obtenir des tentatives de boîte mystique",
  jllb: "Liste des récompenses",
  mhjlbk: "Les récompenses de boîte mystique peuvent inclure : {text} Le montant exact dépend de la récompense réellement obtenue !",
  kkcs: "Peut ouvrir {value} fois",
  mhmx: "Détails de la boîte mystique",
  jpmx: "Détails des prix",
  hdmhs: "Nombre de boîtes mystiques obtenues",
  hyjd: "Progression des amis",
  jplx: "Type de prix",
  dbmc: "Nom du jeton",
  ypf: "Distribué",
  wpf: "Non distribué",
  lq: "Réclamer",
  zblw: "Cadeaux physiques",
  gxczmh: "Félicitations ! Vous avez gagné {amount}. Invitez de nouveaux amis, accomplissez des tâches pour obtenir des boîtes mystiques",
  lxkflq: "Pour les récompenses de cadeaux physiques, veuillez contacter le service client",
  shdz: "Adresse de livraison",
  rwmc: "Nom de la tâche",
  wczt: "État d'achèvement",
  hdmhsl: "Nombre de boîtes mystiques obtenues",
  zblqdz: "Adresse de retrait des cadeaux physiques",
  shr: "Destinataire",
  dh: "Téléphone",
  xxdz: "Adresse détaillée",
  yqmhhdgz: "Règles de l'activité de boîte mystique d'invitation",
  yqyl: "1. Qu'est-ce que le programme d'invitation Biking ?",
  yhhkxt: "Le programme d'invitation Biking est un système de fidélisation destiné à récompenser tous les utilisateurs fidèles qui recommandent Biking à leurs amis.",
  yqhyhdfhjl: "Le programme est simple : il suffit d'inviter des amis pour obtenir de généreuses récompenses.",
  cyhdhqjl: "2. Quelles récompenses peut-on obtenir en participant et en accomplissant des tâches ?",
  hywcrwhdjl: "L'inviteur invite des amis, l'ami invité accomplit les tâches correspondantes, et les deux peuvent obtenir des boîtes mystiques et des récompenses.",
  mhhdgz: "3. Règles d'obtention des boîtes mystiques",
  syrwczc: "1. L'invité complète l'inscription et la vérification d'identité — L'invité obtient 1 tentative",
  syrcz: "2. L'invité dépose ≥100 USDT — L'inviteur et l'invité obtiennent chacun 1 tentative",
  syrcssxf: "3. Les frais de contrat de l'invité atteignent ≥30 USDT — L'inviteur et l'invité obtiennent chacun 2 tentatives",
  qqjyl: "4. Le volume d'options ≥200 USDT — L'inviteur et l'invité obtiennent chacun 2 tentatives",
  yxjyl: "5. Le volume de Gamefi ≥200 USDT avec un taux de mise minimum de 1,2 — L'inviteur et l'invité obtiennent chacun 2 tentatives",
  xhmrjyl: "6. Le volume d'achat au spot ≥500 USDT — L'inviteur et l'invité obtiennent chacun 1 tentative",
  rwqbwc: "Pour chaque invitation, l'inviteur peut obtenir jusqu'à 8 tentatives, et l'invité jusqu'à 9 tentatives. Les invitations multiples s'additionnent.",
  qtsm: "4. Autres informations",
  mhffsj: "1. Temps de distribution des boîtes mystiques — Le système vérifie les tâches toutes les 10 minutes",
  jlffsj: "2. Temps de distribution des récompenses — Distribution manuelle quotidienne à 12h",
  syyhjkcj: "3. Tous les utilisateurs peuvent participer, sans conflit avec d'autres activités",
  mhcjs: "4. Le nombre de tentatives de boîte mystique est réinitialisé le 1er de chaque mois",
  yqmts: "Inviter uniquement les utilisateurs deviennent vos subordonnés, les transactions des subordonnés vous génèrent des commissions",
  fym: "Code de commission",
  fymts: "Inviter et offrir aux subordonnés un taux de commission inférieur ou égal au vôtre, les transactions des subordonnés génèrent des commissions",
  szfym: "Définir le code de commission",
  xzfym: "Ajouter un code de commission",
  lj: "Lien",
  fybl: "Taux de commission",
  yyqhys: "Nombre d'amis invités",
  sykcjs: "Restant à créer",
  tjlx: "Type de recommandation",
  bwjs: "5. Si un individu ou une équipe est détecté en train de frauder pour obtenir des boîtes mystiques, Biking se réserve le droit de supprimer les privilèges du compte. Tous les participants sont considérés comme acceptant les conditions officielles.",
  swmr: "Définir par défaut",
  cffym: "Code de commission en double, veuillez entrer un code valide",
  qxtjfym: "Veuillez d'abord ajouter un code de commission",
  xywdbl: "10 <= Mon taux de commission",
  qsrdybl: "Veuillez entrer le pourcentage correspondant",
  qsrzqsl: "Veuillez entrer une valeur valide",
  qsrbz: "Veuillez entrer une remarque",
  bnbhzf: "Ne peut pas contenir de caractères spéciaux ou d'émojis",
  pfjj: "Distribution refusée",
  pfsb: "Échec de la distribution des récompenses",
  lxkf: "Veuillez contacter le service client pour plus de détails",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/agent/fr.js